import { createContext, useContext } from 'react';

/**
 * ADR-071: the Call Center permissions (a mirror of apps/api/src/permissions.ts — the console cannot import it).
 * The API refuses every action anyway; the panel hides what a person cannot use so nobody meets a refusal.
 */
export const PERM = {
  view: 'centeros.view',
  recordings: 'centeros.recordings',
  call: 'centeros.call',
  contacts: 'centeros.contacts',
  campaigns: 'centeros.campaigns',
  agents: 'centeros.agents',
  lines: 'centeros.lines',
  compliance: 'centeros.compliance',
} as const;
export type Permission = (typeof PERM)[keyof typeof PERM];

/** null = not known yet (or /me failed): nothing is hidden. An empty set = the person may do nothing. */
export type Perms = ReadonlySet<string> | null;

export const canWith = (perms: Perms, need?: string): boolean => !need || !perms || perms.has(need);

export const PermsContext = createContext<Perms>(null);

/** `can(PERM.agents)` — true when allowed or not known yet. */
export const useCan = (): ((need?: string) => boolean) => {
  const perms = useContext(PermsContext);
  return (need?: string) => canWith(perms, need);
};
